import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#F8F6F0] shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/3d68618d053fb0ce08e1408aabac2d46.png"
              alt="Luxury Products by Maram"
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              الرئيسية
            </button>
            <button
              onClick={() => scrollToSection('categories')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              الأقسام
            </button>
            <button
              onClick={() => scrollToSection('featured')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              المنتجات المميزة
            </button>
            <button
              onClick={() => scrollToSection('story')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              قصتي
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#D4AF7A] text-white px-6 py-2 rounded-full hover:bg-[#C9A88A] transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              تواصلي معي
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium text-right"
            >
              الرئيسية
            </button>
            <button
              onClick={() => scrollToSection('categories')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium text-right"
            >
              الأقسام
            </button>
            <button
              onClick={() => scrollToSection('featured')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium text-right"
            >
              المنتجات المميزة
            </button>
            <button
              onClick={() => scrollToSection('story')}
              className="text-white hover:text-[#D4AF7A] transition-colors cursor-pointer whitespace-nowrap font-medium text-right"
            >
              قصتي
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#D4AF7A] text-white px-6 py-2 rounded-full hover:bg-[#C9A88A] transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              تواصلي معي
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
